export default __webpack_public_path__ + "media/images/features/local_delivery/person_walking-a5a718b0ba81d038108f76a64aff3564.png";